import { Button } from "./button";

export interface PaginationProps {
  page: number;
  totalPages: number;
  total?: number;
  disabled?: boolean;
  onPageChange: (page: number) => void;
}

export function Pagination({
  page,
  totalPages,
  total,
  disabled,
  onPageChange,
}: PaginationProps) {
  if (totalPages <= 1) return null;
  return (
    <div
      className="flex items-center justify-end gap-3 text-sm text-muted-foreground"
      data-testid="pagination"
    >
      <Button
        variant="outline"
        size="sm"
        disabled={disabled || page <= 1}
        onClick={() => onPageChange(page - 1)}
      >
        ← Назад
      </Button>
      <span>
        Страница {page} из {totalPages}
        {typeof total === "number" && (
          <>
            <span className="mx-2">·</span>
            всего {total}
          </>
        )}
      </span>
      <Button
        variant="outline"
        size="sm"
        disabled={disabled || page >= totalPages}
        onClick={() => onPageChange(page + 1)}
      >
        Вперёд →
      </Button>
    </div>
  );
}
